// extracted by mini-css-extract-plugin
export default {"titleRow":"N6xOW4FBN3MBFtq9t5hQ","title":"nSloSfgWa7jBd8Xmr1HN","controlBlock":"C83tUaZmFHYNaWel4pQv"};